import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'flexibility_bundle_hub';
export const route = 'flexibility_bundle_hub/[bookingId]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/FlexibilityBundlePage').then(({
  FlexibilityBundlePageHub
}) => ({
  default: FlexibilityBundlePageHub
}))));